import axios from "axios";
import instance from "../../helpers/AxiosInterceptor";

export const listVvinale = () => {
    return instance.get(`/settings/vvinale/list`);
};

export const findVvinale = (id) => {
    return instance.get(`/settings/vvinale/find/${id}`);
};

export const evaluate = (request) => {
    return instance.post(`/vvinale/evaluate`, JSON.stringify(request));
};

export const exportData = (data) => {
    return instance.post(`/vvinale/export`, data, { responseType: "blob" });
};

export const updateVvinale = (request) => {
    return instance.put(`/settings/update`, JSON.stringify(request));
};



